module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (212).ea5b7fd3.jpg";